import {
  PredpisZbierky as PredpisZbierkyGenerated,
  PredpisZbierkyApi,
} from 'indexer-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { indexerPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/types/ClientResponse';
import PredpisZbierky from '../../../model/PredpisZbierky';

const client = new PredpisZbierkyApi(apiConfiguration(indexerPrefixPath));

function map(predpisZbierkyList: PredpisZbierkyGenerated[]): PredpisZbierky[] {
  return predpisZbierkyList.map(predpis => mapPredpis(predpis));
}

function mapPredpis(predpis: PredpisZbierkyGenerated): PredpisZbierky {
  return {
    iri: predpis.iri,
    cislo: predpis.menovka,
    popis: predpis.popis,
    redirectUrl: `/ezbierky/pravne-predpisy${predpis.iri}`,
  };
}

function formatDopytQueryParam(dopyt: string): string {
  return dopyt ? `"${dopyt}"` : '';
}

// eslint-disable-next-line import/prefer-default-export
export const fetchPredpisZbierkyList = async (
  dopyt?: string,
  limit?: number,
  options?: { headers?: object },
): Promise<ClientResponse<PredpisZbierky[]>> => {
  const {
    data,
    status,
  } = await client.getPredpisZbierkyList(formatDopytQueryParam(dopyt), 'predpisZbierky', 'menovka asc', limit, options);
  return {
    data: map(data),
    responseCode: status,
  };
};
